import { create } from "../../../common/utils/zustand_state_manager";
import { useAuthServices } from "./use_services";
import { AuthRepository } from "../../../features/auth/data/repositories/auth_repository";
import { IAuthRepository } from "../../../features/auth/domain/repositories/auth_repository";

/**
 * useAuthRepositories
 */

type RepositoriesState = {
  authRepository: IAuthRepository,
};

export const useAuthRepositories = create<RepositoriesState>(() => ({
  authRepository: new AuthRepository(useAuthServices.getState().authService),
}));